module.exports = __webpack_public_path__ + "static/media/national-concert-hall.6dec7f1a.jpg";